import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getActivePopups } from '../../api/content';
import './PopupOverlay.css';

const PopupOverlay = () => {
    const [popups, setPopups] = useState([]);
    const [visiblePopup, setVisiblePopup] = useState(null);
    const location = useLocation();

    // Map pathname to targetPage values
    const getPageName = (pathname) => {
        if (pathname === '/') return 'home';
        if (pathname.startsWith('/solutions')) return 'solutions';
        if (pathname.startsWith('/products')) return 'products';
        if (pathname.startsWith('/use-cases')) return 'use-cases';
        if (pathname.startsWith('/demo')) return 'demo';
        if (pathname.startsWith('/estimate')) return 'estimate';
        if (pathname.startsWith('/contact')) return 'contact';
        return null;
    };

    useEffect(() => {
        loadPopups();
    }, [location.pathname]);

    const loadPopups = async () => {
        try {
            const currentPage = getPageName(location.pathname);
            if (!currentPage) return;

            const data = await getActivePopups(currentPage);

            // Filter out popups dismissed today
            const today = new Date().toDateString();
            const dismissedPopups = JSON.parse(localStorage.getItem('dismissedPopups') || '{}');

            const activePopups = data.filter(popup => {
                // If popup doesn't allow dismiss, always show it
                if (!popup.allowDismiss) return true;
                // Otherwise, check if dismissed today
                return dismissedPopups[popup.id] !== today;
            });

            setPopups(activePopups);
            if (activePopups.length > 0) {
                setVisiblePopup(activePopups[0]);
            }
        } catch (error) {
            console.error('Failed to load popups', error);
        }
    };

    const handleClose = () => {
        // Move to next popup or close all
        const currentIndex = popups.findIndex(p => p.id === visiblePopup.id);
        if (currentIndex < popups.length - 1) {
            setVisiblePopup(popups[currentIndex + 1]);
        } else {
            setVisiblePopup(null);
        }
    };

    const handleDismissToday = () => {
        if (!visiblePopup) return;

        const today = new Date().toDateString();
        const dismissedPopups = JSON.parse(localStorage.getItem('dismissedPopups') || '{}');
        dismissedPopups[visiblePopup.id] = today;
        localStorage.setItem('dismissedPopups', JSON.stringify(dismissedPopups));

        handleClose();
    };

    const handleClick = () => {
        if (visiblePopup?.linkUrl) {
            window.open(visiblePopup.linkUrl, '_blank');
        }
    };

    if (!visiblePopup) return null;

    return (
        <div className="popup-overlay" onClick={handleClose}>
            <div className="popup-container" onClick={(e) => e.stopPropagation()}>
                {/* Close Button */}
                <button className="popup-close" onClick={handleClose}>✕</button>

                {/* Content */}
                <div
                    className="popup-content"
                    onClick={visiblePopup.linkUrl ? handleClick : undefined}
                    style={{ cursor: visiblePopup.linkUrl ? 'pointer' : 'default' }}
                >
                    {visiblePopup.content ? (
                        <div
                            className="popup-html"
                            dangerouslySetInnerHTML={{ __html: visiblePopup.content }}
                        />
                    ) : visiblePopup.imageUrl ? (
                        <img
                            src={visiblePopup.imageUrl}
                            alt={visiblePopup.title}
                            className="popup-image"
                        />
                    ) : (
                        <div className="popup-title">{visiblePopup.title}</div>
                    )}
                </div>

                {/* Footer */}
                <div className="popup-footer">
                    {visiblePopup.allowDismiss && (
                        <button
                            className="popup-dismiss"
                            onClick={handleDismissToday}
                        >
                            오늘 하루 보지 않기
                        </button>
                    )}
                    <button className="popup-close-btn" onClick={handleClose}>
                        닫기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PopupOverlay;
